import React from "react";
import { DataTableBox } from "./styles";

interface Date {
    year: number;
    month: number;
    day: number;
    date: number;
}
interface Message {
    date: Date;
    message: string;
}
interface User {
    Enter: string;
    Left: string;
    Messages: Array<Message>;
    isBanned: boolean;
}
interface DataTableProps {
    displayData: Array<{[nickname: string]: User}>
}
const DataTable = ({displayData}: DataTableProps) => {
    return (
        <DataTableBox border={0}>
            <thead>
                <tr>
                    <th>닉네임</th>
                    <th>들어온 날짜</th>
                    <th>나간 날짜</th>
                    <th>메세지 개수</th>
                </tr>
            </thead>
            <tbody>
                {
                    displayData.map((obj, idx) => {
                        const nickname = Object.keys(obj)[0];
                        return (
                            (
                                <tr key={idx}>
                                    <td>{nickname.slice(0, 50)}</td>
                                    <td>{obj[nickname].Enter}</td>
                                    <td style={obj[nickname].isBanned ? {color: 'red'} : {}}>{obj[nickname].Left}</td>
                                    <td>{obj[nickname].Messages.length}</td>
                                </tr>
                            )
                        );
                    })
                }
            </tbody>
        </DataTableBox>
    );
};

export default DataTable;